/**
 * Gestionnaire des raccourcis clavier pour l'éditeur riche
 */
export class KeyboardHandler {
    constructor(editor) {
        this.editor = editor;
        this.editorContent = editor.editorContent;
        this.setupKeyboardShortcuts();
    }
    
    setupKeyboardShortcuts() {
        this.editorContent.addEventListener('keydown', event => {
            // Ctrl/Cmd + raccourcis
            if (event.ctrlKey || event.metaKey) {
                switch (event.key.toLowerCase()) {
                    case 'b':
                        event.preventDefault();
                        this.toggleBold();
                        break;
                    case 'i':
                        event.preventDefault();
                        this.toggleItalic();
                        break;
                    case 'u':
                        event.preventDefault();
                        this.toggleUnderline();
                        break;
                    case 'k':
                        event.preventDefault();
                        this.showLinkDialog();
                        break;
                }
            }
            
            // Gestion spéciale des listes avec Tab
            if (event.key === 'Tab') {
                const listItem = this.editor.listManager.getListItem(event.target);
                if (listItem) {
                    event.preventDefault();
                    if (event.shiftKey) {
                        this.editor.listManager.outdent();
                    } else {
                        this.editor.listManager.indent();
                    }
                }
            }
            
            // Gestion de la touche Entrée dans les listes
            if (event.key === 'Enter') {
                if (this.editor.listManager.handleEnterKey(event)) {
                    return; // L'événement a été géré
                }
            }
            
            // Gestion du retour arrière dans les listes vides
            if (event.key === 'Backspace') {
                this.handleBackspaceInList(event);
            }
        });
    }
    
    toggleBold() {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const strongElement = this.findParentElement(range.commonAncestorContainer, 'STRONG');
            
            if (strongElement) {
                // Retirer le gras
                this.unwrapElement(strongElement);
            } else {
                // Appliquer le gras
                const strong = document.createElement('strong');
                this.editor.wrapSelection(strong);
            }
        }
    }
    
    toggleItalic() {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const emElement = this.findParentElement(range.commonAncestorContainer, 'EM');
            
            if (emElement) {
                // Retirer l'italique
                this.unwrapElement(emElement);
            } else {
                // Appliquer l'italique
                const em = document.createElement('em');
                this.editor.wrapSelection(em);
            }
        }
    }
    
    toggleUnderline() {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const uElement = this.findParentElement(range.commonAncestorContainer, 'U');
            
            if (uElement) {
                // Retirer le soulignement
                this.unwrapElement(uElement);
            } else {
                // Appliquer le soulignement
                const u = document.createElement('u');
                this.editor.wrapSelection(u);
            }
        }
    }
    
    showLinkDialog() {
        const selection = window.getSelection();
        if (!selection.isCollapsed) {
            this.editor.saveSelection();
            if (this.editor.wrapAnchorModal) {
                this.editor.wrapAnchorModal.classList.add('is-active');
            }
        }
    }
    
    handleBackspaceInList(event) {
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        
        const range = selection.getRangeAt(0);
        const listItem = this.editor.listManager.getListItem(range.commonAncestorContainer);
        
        if (listItem && range.collapsed && range.startOffset === 0) {
            // Nous sommes au début d'un élément de liste
            if (listItem.textContent.trim() === '') {
                // L'élément de liste est vide, le supprimer ou sortir de la liste
                event.preventDefault();
                this.editor.listManager.exitList(listItem);
            }
        }
    }
    
    findParentElement(node, tagName) {
        let current = node;
        while (current && current !== this.editorContent) {
            if (current.nodeType === Node.ELEMENT_NODE && current.tagName === tagName) {
                return current;
            }
            current = current.parentNode;
        }
        return null;
    }
    
    unwrapElement(element) {
        const parent = element.parentNode;
        while (element.firstChild) {
            parent.insertBefore(element.firstChild, element);
        }
        parent.removeChild(element);
    }
}